import useOnClickOutside from "@/hooks/useOnClickOutside";
import CloseIcon from "@/components/icons/CloseIcon";
import Loading from "@/components/global/Loading";
import toast from "react-hot-toast";
import Input from "../../Input";

import { useRef } from "react";
import { Form, Formik } from "formik";
import { useTranslation } from "next-i18next";
import { forgetSendOtpEmail } from "@/services/auth";
import { getCookie, setCookie } from "cookies-next";
import { emailValidation } from "@/utils/valitation/auth";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";

const ForgotPasswordEmail = ({ Context }) => {
  const { t } = useTranslation("common");
  const ref = useRef();
  const handshake = getCookie("handshake");
  const handleForgotApi = async (
    { email },
    { setSubmitting, setFieldError }
  ) => {
    setSubmitting(true);
    const res = await forgetSendOtpEmail(handshake, email);
    
    if (res?.status == 200) {
      setCookie('email', email)
      Context?.dispatch({ type: "forgotEmail" });
      Context?.dispatch({ type: "otpEmail" });
      toast.success(res?.data?.message);
    } else {
      toast.error(res?.data?.data?.errormsg);
      setFieldError("email", res?.data?.data?.errormsg);
    }
    setSubmitting(false);
  };
  useOnClickOutside([ref], () => Context?.dispatch({ type: "forgotEmail" }))
  useBodyScrollLock();
  return (
    <div ref={ref} className="w-11/12 sm:w-[640px] bg-white rounded-md max-h-[85vh] overflow-y-auto p-4">
      <div className="flex items-center justify-between pb-2 border-b">
        <h2 className="font-bold sm:text-xl">{t("Forgot Password")}</h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "forgot" })}
          className="cursor-pointer text-secondary-800 size-3"
        />
      </div>
      <p className="my-2 max-sm:text-sm text-center max-w-[500px] mx-auto">
        <span className="font-bold text-secondary-800">
          {t("Enter your email address")}{" "}
        </span>
        <span className="font-semibold text-zinc-500">
          {t("and we will send you a verification code to your email address.")}
        </span>
      </p>
      <Formik
        onSubmit={handleForgotApi}
        initialValues={{ email: "" }}
        validationSchema={emailValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <Input
              placeholder="Email Address"
              name="email"
              inputClassName="p-1.5 max-sm:placeholder:text-sm max-sm:text-sm rounded-sm w-full border outline-none mb-3"
              t={t}
            />
            <button
              className="mt-1 bg-primary text-white max-sm:text-sm p-1.5 rounded-md w-full font-semibold uppercase"
              type="submit"
            >
              {isSubmitting ? <Loading /> : t("Send Email")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default ForgotPasswordEmail